import {
  passwordRules,
  zipRules,
  setValidationRule,
  phoneRuleUSOrCanadaIfNotEmpty,
  validDate, validDateBeforeToday,
  Validators
} from '../../../../../lib/validations'

const CURRENT_YEAR = (new Date()).getFullYear()

export const defaultFormFields = {
  first_name: '',
  last_name: '',
  email: '',
  phone: '',
  zip: '',
  card: '',
  cvv: '',
  expMonth: '',
  expYear: '',
  birth_date: null,
  password: null,
  password_confirmation: null,
  terms: null,
  billingEnabled: true,
  doRegister: false,
}
export const allValidationsRules = {
  first_name: setValidationRule('fields.first_name', {
    required: {error: 'First Name is required.'}
  }),
  last_name: setValidationRule('fields.last_name', {
    required: {error: 'Last Name is required.'}
  }),
  email: setValidationRule('fields.email', {
    required: {error: 'Email is required.'}
  }),
  phone: setValidationRule('fields.phone', {
    required: {error: 'Phone is required.'},
    phone: {error: 'Invalid phone number.', rule: phoneRuleUSOrCanadaIfNotEmpty}
  }),
  zip: setValidationRule('fields.zip', zipRules),
  birth_date: setValidationRule('fields.birth_date', {
    required: {error: 'Valid Birth date is required.'},
    invalidDate: {error: 'Birth date is not valid.', rule: validDate},
    pastDate: {error: 'Birth date can not be a future date.', rule: validDateBeforeToday},
  }),
  password: setValidationRule('fields.password', passwordRules),
  password_confirmation: setValidationRule('fields.password_confirmation', {
    confirmed: {error: 'Confirm Password needs to be same as Password.', rule: Validators.sameAs('password')},
  }),
  card: setValidationRule('fields.card', {
      required: {error: 'Credit Card Number is required.'},
      minLength: {error: 'Credit Card Number must be of 10-16 digits.', rule: Validators.minLength(12)},
      maxLength: {error: 'Credit Card Number must be of 10-16 digits.', rule: Validators.maxLength(20)},
    }
  ),
  cvv: setValidationRule('fields.cvv', {
    required: {error: 'Security code is required.'},
    numeric: {error: 'Security code must be numeric.', rule: Validators.numeric},
    minLength: {error: 'Security code must be of 3-4 digits.', rule: Validators.minLength(3)},
    maxLength: {error: 'Security code must be of 3-4 digits.', rule: Validators.maxLength(4)},
  }),
  expMonth: setValidationRule('fields.expMonth', {
    required: {error: 'Expiration Month is required.'},
    numeric: {error: 'Expiration Month must be numeric.', rule: Validators.numeric},
    minLength: {error: 'Expiration Month must be of 1-12.', rule: Validators.minLength(1)},
    maxLength: {error: 'Expiration Month must be of 1-12.', rule: Validators.maxLength(12)},
  }),
  expYear: setValidationRule('fields.expYear', {
    required: {error: 'Expiration Year is required.'},
    numeric: {error: 'Expiration Year must be numeric.', rule: Validators.numeric},
    minValue: {error: `Expiration Year must be greater than or equal to ${CURRENT_YEAR}.`, rule: Validators.minValue(Number(String(CURRENT_YEAR).substring(2)))} ,
  }),
  terms: setValidationRule('fields.terms', {
    required: {error: 'Terms is required.'}
  }),
}

export default {defaultFormFields, allValidationsRules}
